import React from "react";
import { OptionData } from "../shared/interfaces";

const ScratchList = ({ scratches }: { scratches: Array<OptionData> }) => {
  if (scratches && scratches.length > 0) {
    return (
      <aside className="scratches">
        <h6 className="proposition__meta-h6">Scratches</h6>
        <ul className="scratches__list">
          {scratches.map((option, i) => (
            <li key={i} className="scratch">
              <strong>{option.option.name}</strong>{" "}
              <span className="scratch__reason">{option.scratch_reason}</span>
            </li>
          ))}
        </ul>
      </aside>
    );
  } else {
    return null;
  }
};

export default ScratchList;
